//const ASSET_FLOWS_PATH = 'v1/funds/assetFlows';

import { queryOptions, useQuery } from '@tanstack/react-query';
import type { ViewId } from '@/pages/treasury/flows/flow-types';
import { getFundsAssetFlows } from '@/services/api/funds-asset-flows';

export const fundsAssetQueryOptions = (viewId: ViewId, daysAgo: number) =>
  queryOptions({
    queryKey: ['assets', viewId, daysAgo] as const, // Include params in cache key
    queryFn: () => getFundsAssetFlows(viewId, daysAgo),
  });

export const useFundsAssetFlows = (viewId: ViewId, daysAgo: number) => useQuery(fundsAssetQueryOptions(viewId, daysAgo));
